import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appAppCurrencyFormatter]'
})
export class AppCurrencyFormatterDirective {

  private el: HTMLInputElement;

  @Output() formattedValue = new EventEmitter<string>(); // Emits formatted value
  @Output() actualValue = new EventEmitter<number>();    // Emits raw numeric value

  constructor(private elementRef: ElementRef) {
    this.el = this.elementRef.nativeElement;
  }

  @HostListener('input', ['$event']) onInput(event: Event) {
    let value = this.el.value.replace(/[^0-9.]/g, ''); // Remove non-numeric characters except '.'
    const numberValue = parseFloat(value);
    if (!isNaN(numberValue)) {
      this.actualValue.emit(numberValue); // Emit raw numeric value
    } else {
      this.actualValue.emit(0);
    }

    this.el.value = this.formatCurrency(numberValue); // Format the input field
    this.formattedValue.emit(this.el.value); // Emit formatted value
  }

  private formatCurrency(value: number): string {
    if (isNaN(value)) return '';

    return  new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
    }).format(Number(value))

    // return value.toLocaleString('en-IN', {
    //   style: 'currency',
    //   currency: 'INR',
    // });
  }

}
